import { abortableFetch, useEventCallback } from '@eas/common-web';
import { Viewing } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEditViewingDialog() {
  const callApi = useEventCallback(
    (fileId: string, viewingId: string, formData: Viewing) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/${fileId}/viewing/${viewingId}`,
        {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(formData),
        }
      );
    }
  );

  return {
    callApi,
  };
}
